import React from "react";
import ReactDOM from "react-dom/client";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import "@/index.css";
import App from "@/App";

// Global safety net: prevent stray AxiosError promise rejections from turning into
// the red CRA dev overlay. Auth-required requests that return 401 are the common
// culprit (expected before login, on session expiry, or during navigation races)
// and are already handled at the component level via try/catch.
if (typeof window !== "undefined") {
  window.addEventListener("unhandledrejection", (ev) => {
    const err = ev.reason;
    if (err && (err.isAxiosError || err.__silenced || err.response)) {
      // Swallow — the API layer already reported it via toast or logger when relevant.
      ev.preventDefault();
    }
  });
}

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 60_000,
      refetchOnWindowFocus: false,
    },
  },
});

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <App />
    </QueryClientProvider>
  </React.StrictMode>,
);
